<template>
    <div class="bg-white rounded-lg mb-[16px] text-[#2b2b2b] min-h-[600px]">
        <h3 class="text-2xl underline font-light">Liste des demandés de documents</h3>
        <div class="mt-[22px] grid grid-cols-5 gap-10">
            <div v-for="(dmd,idx) in listDemande" :key="idx" v-on:click="showDocPage(getFileById(dmd.document.id).name,dmd.id)" class="h-[300px] w-full border cursor-pointer flex flex-col rounded-lg hover:border-[#5357ec]">
                <div class="grow w-full bg-[#fefefe] overflow-hidden relative rounded-t-lg">
                    <img :src="getFileById(dmd.document.id).img" :alt="getFileById(dmd.document.id).name" class="w-[90%] h-auto top-6 left-1/2 -translate-x-1/2 absolute"/>
                </div>
                <div class="h-[25%] w-full border-t px-4 py-2">
                    <p class="font-extralight">{{ getFileById(dmd.document.id).title }} - Demandé par <span class="underline">{{ decodeJson(dmd.content).nom }}</span></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import API from '../../service/API';
export default {
    name:"ListUserDocDemande",
    data(){
        return {
            isLoading:true,
            listDemande : [],
            files:[
                {
                    id: 15,
                    name: "attest-conge-valid",
                    img: require("./../../assets/uigb/attest_conge.png"),
                    title: "Attestation de départ en congé"
                },
                {
                    id: 16,
                    name: "attest-consultant-valid",
                    img: require("./../../assets/uigb/attest_consultant.png"),
                    title: "Attestation de consultant"
                },
                {
                    id: 17,
                    name: "attest-travail-uigb-valid",
                    img: require("./../../assets/uigb/attest_travail.png"),
                    title: "Attestation de travail"
                },
                {
                    id: 18,
                    name: "certificat-travail-valid",
                    img: require("./../../assets/uigb/certificat_travail.png"),
                    title: "Certificat de travail"
                },
                {
                    id: 19,
                    name: "consultant-absence-not-valid",
                    img: require("./../../assets/uigb/consultant_absence_not.png"),
                    title: "Consultant absence notification"
                },
                {
                    id: 20,
                    name: "domiciliation-salaire-valid",
                    img: require("./../../assets/uigb/domiciliation_salaire.png"),
                    title: "Domiciliation salaire"
                },
                {
                    id: 21,
                    name: "employe-certificat-valid",
                    img: require("./../../assets/uigb/employe_certificat.png"),
                    title: "Employe certificat"
                },
                {
                    id: 22,
                    name: "leave-certificate-valid",
                    img: require("./../../assets/uigb/leave_certificate.png"),
                    title: "Leave certificate"
                },
                {
                    id: 23,
                    name: "notif-fin-contrat-valid",
                    img: require("./../../assets/uigb/notif_fin_contrat.png"),
                    title: "Notification de fin de contrat"
                },
                {
                    id: 24,
                    name: "request-for-cert-valid",
                    img: require("./../../assets/uigb/request_for_cert.png"),
                    title: "Request for certificat"
                },
                {
                    id: 25,
                    name: "resumption-from-leave-valid",
                    img: require("./../../assets/uigb/resumption_from_leave.png"),
                    title: "Resumption from leave"
                },
                {
                    id: 26,
                    name: "salary-certificat-valid",
                    img: require("./../../assets/uigb/salary_certificat.png"),
                    title: "Salary certificat"
                },
                {
                    id: 27,
                    name: "travel-auth-valid",
                    img: require("./../../assets/uigb/travel_auth.png"),
                    title: "Travel authorization"
                }
            ]
        }
    },
    mounted(){
        this.getAllUserDocDemande();
        this.getCongeData();
    },
    methods:{
        getAllUserDocDemande(){
            this.isLoading = true;
            API.get("/user-docs")
            .then((data)=>{
                this.listDemande = data.data["data"]
            })
            .catch(e=>{console.log(e)})
            .finally(()=>{this.isLoading = false})
        },
        getCongeData(){
            API.get("/getAllUsersRemainingLeaveDaysSummary")
            .then()
            .catch(e=>{console.log(e)})
        },
        getFileById(id){
            return this.files.find(file => file.id === id);
        },
        decodeJson(jsonString) {
            try {
                return JSON.parse(jsonString);
            } catch (e) {
                console.error("Invalid JSON string:", e);
                return {name:""};
            }
        },
        showDocPage(name,id){
            this.$router.push({name: name,params: {id: id}})
        }
    }
}
</script>